<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2 page-title">
      <div class="col-sm-6">
        <h3 class="fidelis"><i class="{{ icono }}"></i> {{ modulo.nombre }}</h3>
      </div>
    </div>
  </div>
</div>
